/**
 * Kit fields with no inline variant under the kit name, so the "Customize overview" item-view tab
 * does not offer them. `items` is stripped from the kits query, so its toggle would save a
 * preference that never renders.
 *
 * Kept out of the config hook so it can be asserted without pulling in the authentication chain
 * that hook imports.
 */
export const EXCLUDE_KIT_FIELDS = ['name', 'isRestricted', 'locked', 'items'];
